import dayjs, { time2utc } from '../_util/day';
import { CUSTOMKEY } from './interface';
import { getConfig } from '../hooks/useConfig';
export const defaultFullMinute = 5;
export const defaultPlayerInterval = 1000 * 60 * 5;
export const calculateTimeDifference = (startTime, endTime) => {
  const start = dayjs(startTime);
  const end = dayjs(endTime);
  const years = end.diff(start, 'year');
  if (years > 0) return "".concat(years, "y");
  const months = end.diff(start, 'month');
  if (months > 0) return "".concat(months, "m");
  const days = end.diff(start, 'day');
  if (days > 0) return "".concat(days, "d");
  const hours = end.diff(start, 'hour');
  if (hours > 0) return "".concat(hours, "h");

  // const minutes = end.diff(start, 'minute');
  // if (minutes > 0) return `${minutes}min`;

  // const seconds = end.diff(start, 'second');
  // return `${seconds}s`;

  return '';
};
export const getTimezoneOffset = timezone => {
  const offsetHours = dayjs().tz(timezone).utcOffset() / 60;
  const offsetHoursStr = "".concat(offsetHours >= 0 ? '+' : '-').concat(Math.abs(offsetHours));
  return 'UTC' + offsetHoursStr;
};
export const getTheFullDate = (time, opts) => {
  const {
    forward = true,
    fullMinute = defaultFullMinute
  } = opts || {};
  if (fullMinute === null) {
    return time;
  }
  const day = dayjs(time);
  const dif = day.minute() % fullMinute;
  return time2utc(day.subtract(dif, 'minute').startOf('minute').add(dif && !forward ? fullMinute : 0, 'minute'));
};
function getLastDateRange(hours, fullMinute) {
  return {
    startTime: getTheFullDate(time2utc(dayjs().subtract(hours, 'hour')), {
      fullMinute
    }),
    endTime: getTheFullDate(time2utc(dayjs()), {
      fullMinute
    })
  };
}
export const compareTimes = (time1, time2) => {
  const time1Date = dayjs(time1);
  const time2Date = dayjs(time2);
  if (time1Date.isBefore(time2Date)) {
    return [time1, time2];
  } else {
    return [time2, time1];
  }
};
export const defaultPresets = ['last6Hours', 'last24Hours', 'last2Days', 'last7Days', 'last15Days', 'last30Days', 'today', 'weekToCurrentDate', 'monthToCurrentDate'];
export const presetMap = [{
  value: 'last6Hours',
  label: getConfig().locale.PresetDatePicker.label_last6Hours,
  getShortLabel: () => ({
    shortLabel: '6h'
  }),
  getRange: (timezone, fullMinute) => getLastDateRange(6, fullMinute)
}, {
  value: 'last24Hours',
  label: getConfig().locale.PresetDatePicker.label_last24Hours,
  getShortLabel: () => ({
    shortLabel: '24h'
  }),
  getRange: (timezone, fullMinute) => getLastDateRange(24, fullMinute)
}, {
  value: 'last2Days',
  label: getConfig().locale.PresetDatePicker.label_last2Days,
  getShortLabel: () => ({
    shortLabel: '2d'
  }),
  getRange: (timezone, fullMinute) => getLastDateRange(2 * 24, fullMinute)
}, {
  value: 'last3Days',
  label: getConfig().locale.PresetDatePicker.label_last3Days,
  getShortLabel: () => ({
    shortLabel: '3d'
  }),
  getRange: (timezone, fullMinute) => getLastDateRange(3 * 24, fullMinute)
}, {
  value: 'last7Days',
  label: getConfig().locale.PresetDatePicker.label_last7Days,
  getShortLabel: () => ({
    shortLabel: '7d'
  }),
  getRange: (timezone, fullMinute) => getLastDateRange(7 * 24, fullMinute)
}, {
  value: 'last15Days',
  label: getConfig().locale.PresetDatePicker.label_last15Days,
  getShortLabel: () => ({
    shortLabel: '15d'
  }),
  getRange: (timezone, fullMinute) => getLastDateRange(15 * 24, fullMinute)
}, {
  value: 'last30Days',
  label: getConfig().locale.PresetDatePicker.label_last30Days,
  getShortLabel: () => ({
    shortLabel: '30d'
  }),
  getRange: (timezone, fullMinute) => getLastDateRange(30 * 24, fullMinute)
}, {
  value: 'today',
  label: getConfig().locale.PresetDatePicker.label_today,
  getShortLabel: timezone => {
    return {
      shortLabel: dayjs().tz(timezone).get('hour') + 'h',
      type: 'dashed'
    };
  },
  getRange: (timezone, fullMinute) => {
    const startTime = time2utc(dayjs().tz(timezone).startOf('day'));
    const endTime = time2utc(dayjs().tz(timezone));
    return {
      startTime: getTheFullDate(startTime, {
        fullMinute
      }),
      endTime: getTheFullDate(endTime, {
        fullMinute
      })
    };
  }
}, {
  value: 'weekToCurrentDate',
  label: getConfig().locale.PresetDatePicker.label_weekToCurrentDate,
  getShortLabel: timezone => {
    const day = dayjs().tz(timezone).isoWeekday();
    return {
      shortLabel: "".concat(day, "d"),
      type: 'dashed'
    };
  },
  getRange: (timezone, fullMinute) => {
    const startTime = time2utc(dayjs().tz(timezone).startOf('isoWeek'));
    const endTime = time2utc(dayjs().tz(timezone));
    return {
      startTime: getTheFullDate(startTime, {
        fullMinute
      }),
      endTime: getTheFullDate(endTime, {
        fullMinute
      })
    };
  }
}, {
  value: 'monthToCurrentDate',
  label: getConfig().locale.PresetDatePicker.label_monthToCurrentDate,
  getShortLabel: timezone => ({
    shortLabel: dayjs().tz(timezone).get('date') + 'd',
    type: 'dashed'
  }),
  getRange: (timezone, fullMinute) => {
    const startTime = time2utc(dayjs().tz(timezone).startOf('month'));
    const endTime = time2utc(dayjs().tz(timezone));
    return {
      startTime: getTheFullDate(startTime, {
        fullMinute
      }),
      endTime: getTheFullDate(endTime, {
        fullMinute
      })
    };
  }
}
// {
//   value: 'currentMonth',
//   label: getConfig().locale.PresetDatePicker.label_currentMonth,
//   getRange: (timezone, fullMinute) => {
//     const endTime = time2utc(dayjs().tz(timezone).endOf('month'));
//     const startTime = time2utc(dayjs().tz(timezone).startOf('month'));

//     return {
//       startTime: getTheFullDate(startTime, {  fullMinute }),
//       endTime: getTheFullDate(endTime, { fullMinute }),
//     };
//   },
// },
];
export const getDefaultValue = (data, opts) => {
  var _data$datePreset, _presetMap$find;
  const {
    timeZone,
    earliestTime,
    latestTime,
    fullMinute
  } = opts;
  const _datePreset = (_data$datePreset = data === null || data === void 0 ? void 0 : data.datePreset) !== null && _data$datePreset !== void 0 ? _data$datePreset : presetMap[0].value;
  const _date = (data === null || data === void 0 ? void 0 : data.datePreset) === CUSTOMKEY ? data : (_presetMap$find = presetMap.find(i => i.value === _datePreset)) === null || _presetMap$find === void 0 ? void 0 : _presetMap$find.getRange(timeZone, fullMinute);
  return {
    datePreset: _datePreset,
    startTime: earliestTime ? compareTimes(_date.startTime, getTheFullDate(earliestTime, {
      forward: false,
      fullMinute
    }))[1] : _date.startTime,
    endTime: latestTime ? compareTimes(_date.endTime, getTheFullDate(latestTime, {
      fullMinute
    }))[0] : _date.endTime
  };
};
export const checkAllowableTimeSpan = opts => {
  const {
    allowableTimeSpan,
    endTime,
    startTime
  } = opts;
  return allowableTimeSpan ? dayjs(endTime).diff(dayjs(startTime)) <= allowableTimeSpan : true;
};
export const getOtherActions = opts => {
  const {
    timeZone,
    earliestTime,
    latestTime,
    fullMinute,
    allowableTimeSpan
  } = opts;
  const locale = getConfig().locale.PresetDatePicker;
  return [{
    label: locale.label_yesterday,
    value: getDefaultValue({
      datePreset: 'customDate',
      startTime: time2utc(dayjs().tz(timeZone).subtract(1, 'day').startOf('day')),
      endTime: time2utc(dayjs().tz(timeZone).startOf('day'))
    }, {
      timeZone,
      latestTime,
      earliestTime,
      fullMinute
    })
  }, {
    label: locale.label_previousWeek,
    value: getDefaultValue({
      datePreset: 'customDate',
      startTime: time2utc(dayjs().tz(timeZone).startOf('isoWeek').subtract(1, 'week')),
      endTime: time2utc(dayjs().tz(timeZone).startOf('isoWeek'))
    }, {
      timeZone,
      latestTime,
      earliestTime,
      fullMinute
    })
  }, {
    label: locale.label_previousMonth,
    value: getDefaultValue({
      datePreset: 'customDate',
      startTime: time2utc(dayjs().tz(timeZone).subtract(1, 'month').startOf('month')),
      endTime: time2utc(dayjs().tz(timeZone).startOf('month'))
    }, {
      timeZone,
      latestTime,
      earliestTime,
      fullMinute
    })
  }].filter(i => dayjs(i.value.startTime).isBefore(i.value.endTime) && checkAllowableTimeSpan({
    ...i.value,
    allowableTimeSpan
  }));
};